import { render, staticRenderFns } from "./Nofound.vue?vue&type=template&id=33c8da38&scoped=true"
import script from "./Nofound.vue?vue&type=script&lang=js"
export * from "./Nofound.vue?vue&type=script&lang=js"
import style0 from "./Nofound.vue?vue&type=style&index=0&id=33c8da38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c8da38",
  null
  
)

export default component.exports